import { cn } from '@/lib/utils'

const FIELD_BASE =
  'rounded-md border bg-white dark:bg-neutral-950 px-3 py-2 text-sm text-neutral-900 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-60'

/** An input or select; red border when it carries an error. */
export function fieldClass(invalid?: boolean, className?: string): string {
  return cn(FIELD_BASE, invalid ? 'border-red-500 dark:border-red-500' : 'border-neutral-300 dark:border-neutral-700', className)
}

export const LABEL = 'block text-sm font-medium text-neutral-800 dark:text-neutral-200'
export const HINT = 'text-xs text-neutral-500 dark:text-neutral-400'

/** One segment of a small toggle group (Include | Own rule | Exclude, One-off | Recurring). */
export function segmentClass(selected: boolean): string {
  return cn(
    'px-3 py-1.5 text-sm font-medium transition-colors first:rounded-l-md last:rounded-r-md border -ml-px first:ml-0 disabled:cursor-not-allowed',
    selected
      ? 'relative z-10 border-blue-600 bg-blue-600 text-white'
      : 'border-neutral-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-800',
  )
}
